module.exports = __webpack_public_path__ + "ad05d8d10d2ef78fd2e2d2bc43a33bd6.svg";